<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 48 32"
  >
    <g>
      <path
        fill="#010F37"
        d="M45.324 2.667c-0.568 0.001-1.093 0.178-1.526
      0.48l0.009-0.006-9.142
      5.824v-4.982c-0.095-2.222-1.92-3.987-4.156-3.987-0.058 0-0.116 0.001-0.173
      0.004l0.008-0h-26.027c-0.048-0.002-0.104-0.003-0.16-0.003-2.237 0-4.061
      1.765-4.156 3.978l-0 0.009v24.032c0.095 2.222 1.92 3.987 4.156 3.987 0.056
      0 0.112-0.001 0.168-0.003l-0.008 0h26.027c0.048 0.002 0.104 0.003 0.16
      0.003 2.237 0 4.061-1.765 4.156-3.978l0-0.009v-4.982l9.132 5.824c0.425
      0.297 0.952 0.474 1.52 0.474 1.459 0 2.645-1.17
      2.672-2.623l0-0.002v-21.417c-0.008-1.451-1.186-2.623-2.638-2.623-0.008
      0-0.016 0-0.023 0h0.001zM32 28.016c-0.107 0.751-0.745 1.322-1.517
      1.322-0.046 0-0.092-0.002-0.138-0.006l0.006 0h-26.034c-0.040 0.004-0.085
      0.006-0.132 0.006-0.772
      0-1.411-0.571-1.516-1.314l-0.001-0.008v-24.032c0.107-0.751 0.745-1.322
      1.517-1.322 0.046 0 0.092 0.002 0.138 0.006l-0.006-0h26.027c0.040-0.004
      0.085-0.006 0.132-0.006 0.772 0 1.411 0.571 1.516 1.314l0.001
      0.008v24.032zM45.334 26.707l-0.1-0.108-10.566-6.734v-7.74l10.667-6.791z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
